<mat-sidenav-container class="app-container">

  <mat-sidenav
    #sidenav
    [opened]="sidenavOpen()"
    mode="over"
    class="app-sidenav"
  >
    <app-sidebar />
  </mat-sidenav>

  <mat-sidenav-content class="app-content">
    <app-header (menuClick)="toggleSidenav()" />

    <main class="main-content">
      <router-outlet />
    </main>

    <app-footer />
  </mat-sidenav-content>

</mat-sidenav-container>
